import { render } from "./topics-index.vue?vue&type=template&id=06eef66a"
import script from "./topics-index.vue?vue&type=script&lang=js"
export * from "./topics-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__